/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core'

/**
 * Use this Directive to automatically focus an element on page load.
 * Provide input value if you which to conditionally apply the autofocus (default: true)
 */
@Directive({
  selector: '[autoFocus]',
  standalone: false,
})
export class AutoFocusDirective implements AfterViewInit, OnDestroy {
  private elementRef = inject(ElementRef)

  @Input() autoFocus = true

  private timeOut?: ReturnType<typeof setTimeout>

  ngAfterViewInit(): void {
    if (this.autoFocus) {
      // Delay the focus to prevent flaky behaviour
      this.timeOut = setTimeout(() => {
        this.elementRef.nativeElement.focus()
      }, 100)
    }
  }

  ngOnDestroy() {
    if (this.timeOut) {
      clearTimeout(this.timeOut)
    }
  }
}
